import { useMemo } from "react";
import { Badge, IconButton } from "@radix-ui/themes";
import { Cross2Icon } from "@radix-ui/react-icons";
import { SelectOption } from "@/components/shared/select";

interface TagListProps {
  options: SelectOption[];
  value?: string[];
  loading?: boolean;
  className?: string;
  onRemove: (value: string) => void;
}

export function TagList({
  value,
  options,
  loading,
  className,
  onRemove,
}: TagListProps) {
  const items = useMemo(() => {
    const optionMap = new Map(options.map((o) => [o.value, o.label]));

    return (
      value?.map((value) => ({
        value,
        label: optionMap.get(value) ?? value,
        onClick: () => onRemove(value),
      })) ?? []
    );
  }, [value, options, onRemove]);

  if (loading) {
    return <></>;
  }

  return (
    <>
      {items.map(({ value, label, onClick }) => (
        <Badge
          key={value}
          color="blue"
          variant="soft"
          size="2"
          className={className}
        >
          {label}

          <IconButton
            color="gray"
            variant="ghost"
            highContrast
            size="1"
            onClick={onClick}
          >
            <Cross2Icon />
          </IconButton>
        </Badge>
      ))}
    </>
  );
}
